import React from 'react';
import { UserProfileType } from 'entities/user/model/types';
import { useUpdateUserDataDefaultValues } from 'entities/users/lib';
import { useChangeDataMutation } from 'features/changeUserData/api/changeUserDataApi';
import { Resolver, SubmitHandler, useForm } from 'react-hook-form';
import { UserDataFormType } from 'entities/users/types';
import { yupResolver } from '@hookform/resolvers/yup';
import { validationSchemaUserData } from 'entities/users/model';
import { UserDataCard } from 'entities/users/ui/UserDataCard';

type UpdateUserDataCardPropsType = {
  user: UserProfileType;
};
export const UpdateUserDataCard = ({ user }: UpdateUserDataCardPropsType) => {
  const defaultValues = useUpdateUserDataDefaultValues(user);

  const [changeData] = useChangeDataMutation();

  const updateUserDataForm = useForm<UserDataFormType>({
    resolver: yupResolver(validationSchemaUserData) as Resolver<UserDataFormType>,
    defaultValues,
  });

  const onSubmit: SubmitHandler<UserDataFormType> = ({
    phone,
    user_role_ids,
    source_id,
    channel,
    is_b2b,
    is_b2c,
    is_b2cr,
  }) => {
    changeData({
      id: user.id,
      body: {
        phone,
        user_role_ids,
        source_id,
        channel,
        is_b2b,
        is_b2c,
        is_b2cr,
      },
    });
  };

  return (
    <UserDataCard
      form={updateUserDataForm}
      onSubmit={onSubmit}
    />
  );
};
